import _ from "lodash";

export const getIPODetailID = (ipo) => _.get(ipo, "id", null);
export const getIPODetailAllotmentAnnouncementDateText = (ipo) =>
  _.get(ipo, ["allotment_announcement_date", "text"], "");
export const getIPODetailAllotmentAnnouncementDateValue = (ipo) =>
  _.get(ipo, ["allotment_announcement_date", "value"], "");
export const getIPODetailBallotingDateText = (ipo) =>
  _.get(ipo, ["balloting_date", "text"], "");
export const getIPODetailBallotingDateValue = (ipo) =>
  _.get(ipo, ["balloting_date", "value"], "");
export const getIPODetailBoard = (ipo) => _.get(ipo, ["board"], "");
export const getIPODetailCloseDatetimeText = (ipo) =>
  _.get(ipo, ["close_datetime", "text"], "");
export const getIPODetailCloseDatetimeTimestamp = (ipo) =>
  _.get(ipo, ["close_datetime", "timestamp"], "");
export const getIPODetailCloseDatetimeValue = (ipo) =>
  _.get(ipo, ["close_datetime", "value"], "");
export const getIPODetailCompanyLogoPublicUrl = (ipo) =>
  _.get(ipo, ["company_logo", "public_url"], "");
export const getIPODetailCompanyName = (ipo) =>
  _.get(ipo, ["company_name"], "");
export const getIPODetailCompanyRegNo = (ipo) =>
  _.get(ipo, ["company_reg_no"], "");
export const getIPODetailCompanyWebsiteLink = (ipo) =>
  _.get(ipo, ["company_website_link"], "");
export const getIPODetailIssueHouse = (ipo) => _.get(ipo, ["issue_house",'text'], "");
export const getIPODetailIssueNo = (ipo) => _.get(ipo, ["issue_no"], "");
export const getIPODetailListingDateText = (ipo) =>
  _.get(ipo, ["listing_date", "text"], "");
export const getIPODetailListingDateValue = (ipo) =>
  _.get(ipo, ["listing_date", "value"], "");
export const getIPODetailLotSizeText = (ipo) =>
  _.get(ipo, ["lot_size", "text"], "");
export const getIPODetailLotSizeValue = (ipo) =>
    _.get(ipo, ["lot_size", "value"], "");
export const getIPODetailOpenDatetimeText = (ipo) =>
  _.get(ipo, ["open_datetime", "text"], "");
export const getIPODetailOpenDatetimeValue = (ipo) =>
  _.get(ipo, ["open_datetime", "value"], "");
export const getIPODetailOpenDatetimeTimestamp = (ipo) =>
  _.get(ipo, ["open_datetime", "timestamp"], "");
export const getIPODetailPricePerShare = (ipo) =>
  _.get(ipo, ["price_per_unit", "full_text"], "");
export const getIPODetailFinalPricePerShare = (ipo) =>
    _.get(ipo, ["final_price_per_unit", "full_text"], "");
export const getIPODetailPricePerShareValue = (ipo) =>
  _.get(ipo, ["price_per_unit", "value"], "");
export const getIPODetailPublicIssue = (ipo) =>
  _.get(ipo, ["public_issue", "text"], "");
export const getIPODetailRelevantDocuments = (ipo) =>
  _.get(ipo, ["relevant_documents"], []);
export const getIPODetailRelevantLink = (ipo) =>
  _.get(ipo, ["relevant_links"], []);
export const getIPODetailStockCode = (ipo) => _.get(ipo, ["stock_code"], "");
export const getIPODetailStockName = (ipo) => _.get(ipo, ["stock_name"], "");
export const getCurrencyCodeSymbol = ipo => _.get(ipo, ["currency_code","symbol"], "");
export const getIPODetailCompanyLogoBase64 = ipo => _.get(ipo,['company_logo','base64'],'')
export const getIPODetailCompanyLogoExtension = ipo => _.get(ipo,['company_logo','png'],'')
export const getIPODetailCompanyLogoFull = ipo => `data:image/${getIPODetailCompanyLogoExtension(ipo)};base64, ${getIPODetailCompanyLogoBase64(ipo)}`
export const getIPODetailShouldDisable = ipo => _.get(ipo, ["metadata", "should_disable"], "");
export const getIPODetailPriceChanged = ipo => _.get(ipo, ["metadata", "price_change"], "");

//subsribed ipo
export const getSubscribedIPODetailsAdaCode = ipo => _.get(ipo,['ada_code'],'')
export const getSubscribedIPODetailsApplicationStatus = ipo => _.get(ipo,['status', 'text'],'')
export const getSubscribedIPODetailsBranchCode = ipo => _.get(ipo,['branch_code'],'')
export const getSubscribedIPODetailsCancelledAt = ipo => _.get(ipo,['cancelled_at'],'')
export const getSubscribedIPODetailsCDSBranchCode = ipo => _.get(ipo,['cds_branch_code'],'')
export const getSubscribedIPODetailsCDSNumber = ipo => _.get(ipo,['cds_number'],'')
export const getSubscribedIPODetailsClientCode = ipo => _.get(ipo,['client_code'],'')
export const getSubscribedIPODetailsClientName = ipo => _.get(ipo,['client_name'],'')
export const getSubscribedIPODetailsIPO = ipo => _.get(ipo,['ipo'],'')
export const getSubscribedIPODetailsCurrencyCodeSymbol = ipo => _.get(ipo,['currency_code','symbol'],'')
export const getSubscribedIPODetailsID = ipo => _.get(ipo,['id'],'')
export const getSubscribedIPODetailsIsCancellable = ipo => _.get(ipo,['is_cancellable'],false)
export const getSubscribedIPODetailsNewIC = ipo => _.get(ipo,['new_ic'],'')
export const getSubscribedIPODetailsOldIC = ipo => _.get(ipo,['old_ic'],'')
export const getSubscribedIPODetailsNumberOfShareAllottedText = ipo => _.get(ipo,['number_of_share_allotted','text'],'')
export const getSubscribedIPODetailsNumberOfShareAllottedValue = ipo => _.get(ipo,['number_of_share_allotted','value'],'')
export const getSubscribedIPODetailsNumberOfShareAppliedText = ipo => _.get(ipo,['number_of_share_applied','text'],'')
export const getSubscribedIPODetailsNumberOfShareAppliedValue = ipo => _.get(ipo,['number_of_share_applied','value'],'')
export const getSubscribedIPODetailsNumberOfShareRefundedText = ipo => _.get(ipo,['number_of_share_refunded','text'],'')
export const getSubscribedIPODetailsNumberOfShareRefundedValue = ipo => _.get(ipo,['number_of_share_refunded','value'],'')
export const getSubscribedIPODetailsTotalAmountAppliedText = ipo => _.get(ipo,['total_amount_applied','full_text'],'')
export const getSubscribedIPODetailsTotalAmountAppliedValue = ipo => _.get(ipo,['total_amount_applied','value'],'')

export const getSubscribedIPODetailsTotalAmountAllottedText = ipo => _.get(ipo,['total_amount_allotted','full_text'],'')
export const getSubscribedIPODetailsTotalAmountAllottedValue = ipo => _.get(ipo,['total_amount_allotted','value'],'')

export const getSubscribedIPODetailsTotalAmountRefundedText = ipo => _.get(ipo,['total_amount_refunded','full_text'],'')
export const getSubscribedIPODetailsTotalAmountRefundedValue = ipo => _.get(ipo,['total_amount_refunded','value'],'')

export const getSubscribedIPODetailsTotalOriginalTrustAmount = ipo => _.get(ipo,['total_original_trust_amount','full_text'],'')
export const getSubscribedIPODetailsTotalBalanceTrustAmount = ipo => _.get(ipo,['total_balance_trust_amount','full_text'],'')
export const getSubscribedIPODetailsTotalOriginalTrustAmountValue = ipo => _.get(ipo,['total_original_trust_amount','value'],'')
export const getSubscribedIPODetailsTotalBalanceTrustAmountValue = ipo => _.get(ipo,['total_balance_trust_amount','value'],'')
export const getSubscribedIPODetailsTotalTransactionTrustAmount = ipo => _.get(ipo,['total_transaction_trust_amount','full_text'],'')
export const getSubscribedIPODetailsTotalTransactionTrustAmountValue = ipo => _.get(ipo,['total_transaction_trust_amount','value'],'')
export const getSubscribedIPODetailsPricePerUnitValue = ipo => _.get(ipo,['price_per_unit','value'],'')
export const getSubscribedIPODetailsPricePerUnitText= ipo => _.get(ipo,['price_per_unit','text'],'')
export const getSubscribedIPODetailsPricePerUnitFullText = ipo => _.get(ipo,['price_per_unit','full_text'],'')
export const getSubscribedIPODetailsRaceValue = ipo => _.get(ipo,['race','value'],'')
export const getSubscribedIPODetailsRaceText = ipo => _.get(ipo,['race','text'],'')
export const getSubscribedIPODetailsReferenceNo = ipo => _.get(ipo,['reference_no'],'')
export const getSubscribedIPODetailsRemisierCode= ipo => _.get(ipo,['remisier_code'],'')
export const getSubscribedIPODetailsResultUpdatedAt= ipo => _.get(ipo,['result_updated_at'],'')
export const getSubscribedIPODetailsCancelledAtText = ipo => _.get(ipo,['cancelled_at','text'],'')

//ipo
export const getIpoConfigData = ipo => _.get(ipo,['ipo','ipoConfig'],null)


//ipo config
export const getIpoConfigRaces = ipo => _.get(ipo,['races'],[])
export const getIpoConfigSubscriptionStatus = ipo => _.get(ipo,['subscriptionStatus'],null)
export const getIpoConfigMetadataTotalTrustBalance = ipo => _.get(ipo,['metadata','total_trust_balance'],0)

//ipo detail
export const getIpoDetailDataDate = ipo => _.get(ipo,['data_date'],'')
export const getIpoDetailOriginalAmount = ipo => _.get(ipo,['original_amount','full_text'],'')
export const getIpoDetailBalanceAmount = ipo => _.get(ipo,['balance_amount','full_text'],'')
export const getIpoDetailOriginalAmountValue = ipo => _.get(ipo,['original_amount','value'],'')
export const getIpoDetailBalanceAmountValue = ipo => _.get(ipo,['balance_amount','value'],'')
export const getIpoDetailCurrencyCodeSymbol = ipo => _.get(ipo,['currency_code','symbol'],'')
export const getIpoDetailReferenceNo = ipo => _.get(ipo,['reference_no'],'')
export const getIpoDetailCancelledDateTime = ipo => _.get(ipo,['cancelled_datetime'],'')
export const getIpoDetailSubmittedDateTime = ipo => _.get(ipo,['submitted_datetime'],'')
export const getIpoDetailTransactionAmount = ipo => _.get(ipo,['transaction_amount','full_text'],'')
export const getIpoDetailTransactionAmountValue = ipo => _.get(ipo,['transaction_amount','value'],'')
export const getIpoDetailTransactionDateTime= ipo => _.get(ipo,['transaction_datetime','text'],'')
